/** @format */

import NumberFormat from 'react-number-format';
import {ActionColumn} from './action_column';
import {SingleDesign} from './single_design';
import {Table} from '@sttark/design-system';
import React, {useState} from 'react';

export const OrdersDesignsList = props => {
    return props.renderData.shipment_packages.map((pkg, index) => {
        const [isShowingThumbnails, setIsShowingThumbnails] = useState(false);

        const handleToggleThumbnails = () => {
            setIsShowingThumbnails(!isShowingThumbnails);
        };
        return (
            <div className="design_orders_list-02lt" key={pkg.id}>
                <h3 className="design_orders_list-02lt_pkg-title">Package {index + 1}</h3>
                <Table
                    columns={[
                        {
                            index: 'filename',
                            title: (
                                <div className="table-column-title d-flex align-items-center justify-content-start">
                                    <b className="m-0 p-0">Filename</b>
                                    <button
                                        className="color-accent-primary ml-2 my-0 p-0"
                                        onClick={handleToggleThumbnails}>
                                        <u>
                                            {isShowingThumbnails ? 'Hide Artwork' : 'Show Artwork'}
                                        </u>
                                    </button>
                                </div>
                            ),
                            key: 'filename'
                        },
                        {
                            index: 'design_id',
                            title: 'Design ID',
                            key: 'design_id'
                        },
                        {
                            index: 'qty',
                            title: 'Qty',
                            key: 'qty'
                        },
                        {
                            index: 'action',
                            key: 'action',
                            title: ''
                        }
                    ]}
                    rows={pkg.designs_packages.map(pgkDesignOrder => {
                        const designOrder = props.renderData.designs_orders.find(
                            ({id}) => id === pgkDesignOrder.design_id
                        );

                        return {
                            key: designOrder.id,
                            filename: (
                                <SingleDesign
                                    order={{}}
                                    designOrder={designOrder}
                                    showThumbnails={isShowingThumbnails}
                                />
                            ),
                            design_id: designOrder.design_id,
                            qty: (
                                <NumberFormat
                                    value={pgkDesignOrder.shipped_qty}
                                    displayType="text"
                                    thousandSeparator
                                />
                            ),
                            action: <ActionColumn {...designOrder} />
                        };
                    })}
                />
            </div>
        );
    });
};
